import { Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts"

type Props = {
  months: string[]
  data: number[]
  color: string
}

interface IChartDataPoint {
  month: string
  value: number
}

export function GrowthChart({ months, data, color }: Props) {
  const chartData: IChartDataPoint[] = months.map((month, index) => ({
    month,
    value: data[index] ?? 0,
  }))

  return (
    <ResponsiveContainer width="100%" height={250}>
      <LineChart data={chartData}>
        <XAxis dataKey="month" />
        <YAxis allowDecimals={false} />
        <Tooltip />
        <Line dataKey="value" stroke={color} dot={false} />
      </LineChart>
    </ResponsiveContainer>
  )
}
